import { GoogleMap as Map, Marker } from '@react-google-maps/api'

import { GoogleMapOptions } from 'lib/customGoogleMapOptions'
import useCheckBreakpoint from 'lib/checkBreakpoint'

interface Props {
  lat: number
  lon: number
  zoomLabel: number
  coinLockers: any
  oldCoinLockers?: any
  mapRef: any
  initGoogleMap: (map) => void
  scrollToRecommendedCoinLockerSection: (id: number, isOld?: boolean) => void
  // onChangeZoomMap: () => void
}

const CoinLockerMapComponent: React.FC<Props> = ({
  lat,
  lon,
  zoomLabel,
  coinLockers,
  oldCoinLockers = [],
  mapRef,
  initGoogleMap,
  scrollToRecommendedCoinLockerSection,
}: // onChangeZoomMap,
Props): JSX.Element => {
  const { isMobile, isTablet } = useCheckBreakpoint()

  const _googleMapOptions: google.maps.MapOptions = {
    fullscreenControl: false,
    zoomControl: (!isTablet && !isMobile) || false,
    zoomControlOptions: { position: 1 },
    styles: GoogleMapOptions,
    disableDefaultUI: true,
    minZoom: 6,
    maxZoom: 16,
  }

  // Ensure we have arrays to avoid issues
  const regularLockers = Array.isArray(coinLockers) ? coinLockers : []
  const oldLockers = Array.isArray(oldCoinLockers) ? oldCoinLockers : []

  return (
    <>
      <Map
        ref={mapRef}
        mapContainerStyle={{
          width: '100%',
          height: '100%',
          paddingTop: isMobile ? '100%' : '50.27%',
        }}
        center={{
          lat: lat,
          lng: lon,
        }}
        zoom={zoomLabel}
        options={_googleMapOptions}
        onLoad={(map) => initGoogleMap(map)}
      >
        {regularLockers.map((coinLocker, index) => (
          <Marker
            position={{
              lat: parseFloat(coinLocker.latitude),
              lng: parseFloat(coinLocker.longitude),
            }}
            key={`regular-${index}`}
            icon={'/marker_coin_locker.svg'}
            onClick={() => {
              scrollToRecommendedCoinLockerSection(coinLocker.id, false)
            }}
          />
        ))}

        {oldLockers.map((coinLocker, index) => (
          <Marker
            position={{
              lat: parseFloat(coinLocker.latitude),
              lng: parseFloat(coinLocker.longitude),
            }}
            key={`old-${index}`}
            icon={'/marker_coin_locker.svg'}
            onClick={() => {
              scrollToRecommendedCoinLockerSection(coinLocker.id, true)
            }}
          />
        ))}
      </Map>
    </>
  )
}

export default CoinLockerMapComponent
